<template>
  <!--eslint-disable-->
  <v-navigation-drawer app :value="drawer" :temporary="isMobile" :fixed="isDesktop" stateless dark :mini-variant="mini">
    <v-toolbar flat height="70">
      <v-list>
        <v-list-tile>
          <v-list-tile-action v-if="isMobile">
            <v-avatar><img src="@/assets/logo-rl.jpg" alt="avatar"></v-avatar>
          </v-list-tile-action>
          <v-list-tile-action v-else @click="toggle">
            <v-avatar><img src="@/assets/logo-rl.jpg" alt="avatar"></v-avatar>
          </v-list-tile-action>
          <v-list-tile-title class="title" v-if="!mini">
            RL Space
          </v-list-tile-title>
          <v-list-tile-action v-if="!mini">
            <v-btn v-if="isMobile" icon @click="hideDrawer">
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-btn v-else icon @click="toggle">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>

    <v-list dense class="pa-0">
      <template v-for="(item, i) in filteredMenu">
        <v-list-tile v-if='!item.childs' :key="'lvl1_' + i" :to='item.route'
                     active-class="primary--text success--text">
          <v-list-tile-action>
            <v-tooltip v-if="mini" bottom >
              <template v-slot:activator="{ on }">
                <v-icon dark v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span >{{ item.title }}</span>
            </v-tooltip>
            <v-icon v-else dark>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>

        <v-list-group :value='opened(item.childs)' v-else :key="'lvl1_' + i" >
          <v-tooltip  v-if="mini" slot="prependIcon" bottom >
            <template v-slot:activator="{ on }">
              <v-icon   v-on="on">{{ item.icon }}</v-icon>
            </template>
            <span>{{ item.title }}</span>
          </v-tooltip>
          <v-icon v-else slot="prependIcon">{{ item.icon }}</v-icon>
          <v-list-tile slot="activator">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile :class="{ 'pl-3': !mini, 'pl-2': mini }" v-for="sub_item in item.childs"
                       :to="sub_item.route" active-class="primary--text success--text">
            <v-list-tile-action>
              <v-tooltip v-if="mini"  bottom >
                <template v-slot:activator="{ on }">
                  <v-icon :size="mini ? '16' : ''" v-on="on">{{ sub_item.icon }}</v-icon>
                </template>
                <span>{{ sub_item.title }}</span>
              </v-tooltip>
              <v-icon v-else :size="mini ? '16' : ''" >{{ sub_item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ sub_item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </template>
    </v-list>

    <template v-if="bookmarks.length > 0 && mini">
      <v-divider my-2></v-divider>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-list class="pa-0">
            <v-list-tile
              v-bind="attrs"
              v-on="on"
              title="Bookmarks"
              active-class="primary--text success--text"
            >
              <v-list-tile-action>
                <v-icon>bookmark_border</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>
                Bookmarks
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </template>
        <v-list dark>
          <v-list-tile :class="{ 'pl-3': !mini, 'pl-2': mini }" :title="sub_item.title" v-for="sub_item in bookmarks"
                       :to="sub_item.value" active-class="primary--text success--text">
            <v-list-tile-title>{{ sub_item.title }}</v-list-tile-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="editBookmark(sub_item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn small icon @click.prevent="deleteBookmark(sub_item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>

    <template v-if="bookmarks.length > 0 && !mini">
      <v-divider my-2></v-divider>
      <v-list dense class="pt-0">
        <v-subheader>Bookmarks</v-subheader>
        <template v-for="(item, i) in bookmarks">
          <v-list-tile :key="'history_' + i" :title="item.title" :to='item.value'>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="editBookmark(item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn small icon @click.prevent="deleteBookmark(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-list-tile>
        </template>
      </v-list>
    </template>

    <template v-if="historyList.length > 0 && mini">
      <v-divider my-2></v-divider>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-list class="pa-0">
            <v-list-tile
                v-bind="attrs"
                v-on="on"
                title="History"
                active-class="primary--text success--text"
            >
              <v-list-tile-action>
                <v-icon>history</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>
                History
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </template>
        <v-list dark>
          <v-list-tile :class="{ 'pl-3': !mini, 'pl-2': mini }" :title="sub_item.title" v-for="sub_item in historyList"
                       :to="sub_item.value" active-class="primary--text success--text">
            <v-list-tile-content>
              <v-list-tile-title>{{ sub_item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn small icon @click="editBookmark(sub_item)">
                <v-icon>star</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>

    <template v-if="historyList.length > 0 && !mini">
      <v-divider my-2></v-divider>
      <v-list dense class="pt-0">
        <v-subheader>History</v-subheader>
        <template v-for="(item, i) in historyList">
          <v-list-tile :key="'history_' + i" :title="item.title" :to='item.value'>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="editBookmark(item)">
              <v-icon>star</v-icon>
            </v-btn>
          </v-list-tile>
        </template>
      </v-list>
    </template>

    <bookmark-dialog ref="bookmarkDialog" @refresh="loadBookmarks"></bookmark-dialog>

    <v-switch
      v-if="isMobile"
      :label="`Dark Theme`"
      v-model="isDark"
      hide-details
      class="ml-3"
    />
  </v-navigation-drawer>
</template>

<script>
  import * as mixins from '@/mixins/'
  import * as storage from '@/utils/storage/'
  import bookmark from '@/components/bookmark-dialog'
  import {mapGetters} from "vuex";

  export default {
    name: 'Navigation',
    mixins: [mixins.user, mixins.history, mixins.preloader],
    props: ['drawer'],
    data() {
      return {
        mini: false,
        bookmarks: [],
        isDark: false,
        menu: [
          { title: 'Main', icon: 'dashboard', route: '/', feature: this.$features.DASHBOARD },
          { title: 'Workline', icon: 'work', route: '/workline', feature: this.$features.CALENDAR_SELECT },
          { title: 'Spaces', icon: 'cloud', route: '/spaces', feature: this.$features.SPACES },
          { title: 'Projects', icon: 'extension', route: '/projects', feature: this.$features.PROJECTS },
          { title: 'Track time confirmation', icon: 'timer', route: '/times', feature: this.$features.TIMES },
          { title: 'Users', icon: 'supervised_user_circle', route: '/users', feature: this.$features.USERS },
          { title: 'Instances', icon: 'visibility', route: '/instances', feature: this.$features.INSTANCES },
          { title: 'Roles', icon: 'group', route: '/roles', feature: this.$features.ROLES },
          { title: 'Features', icon: 'thumb_up', route: '/features', feature: this.$features.FEATURES },
          {
            title: 'Reports', icon: 'assignment', feature: this.$features.REPORTS, childs:
              [
                { title: 'Payable Hours', icon: 'percent', route: '/reports/payable-hours' },
                { title: 'Summary', icon: 'pie_chart', route: '/reports/summary' },
                { title: 'Track calendar', icon: 'calendar_today', route: '/reports/calendar' },
              ]
          },
        ],
        isActiveHistory: true,
        isActiveBookmarks: true,
      }
    },
    methods: {
      opened(childs) {
        return childs.some(item => this.$route.path == item.route)
      },
      toggle() {
        this.mini = !this.mini
        storage.drawer.set(this.mini)
      },
      hideDrawer() {
        this.$emit('close')
        storage.drawer.set(false)
      },
      loadBookmarks() {
        this.background(this.$api.bookmarks.list({ unlimit: 1 }).then(response => {
          this.bookmarks = response.data.data ? response.data.data : response.data
        }))
      },
      editBookmark(bookmark) {
        this.$refs.bookmarkDialog.open(bookmark)
      },
      deleteBookmark(bookmark) {
        this.background(this.$api.bookmarks.delete(bookmark.id).then(() => {
          this.loadBookmarks()
        }))
      }
    },
    computed: {
      ...mapGetters(['darkTheme']),
      historyList() {
        return [...this.history].reverse()
      },
      filteredMenu() {
        let result = []
        if (this.user) {
          this.menu.map(item => {
            this.featureAllowed(item.feature) ? result.push(item) : false
          })
        }

        return result
      }
    },
    watch: {
      $route: {
        handler: function () {
          if (this.isMobile) {
            this.hideDrawer()
          }
        },
        deep: true
      },
      isDark(value) {
        if (this.isMobile) {
          this.$store.dispatch('changeTheme', value)
        }
      },
    },
    mounted() {
      this.mini = storage.drawer.get()

      let preload = [this.loadBookmarks()]
      preload.forEach(item => this.background(item))
      this.isDark = this.darkTheme
    },
    components: {
      'bookmark-dialog': bookmark
    }
  }
</script>
